import * as Yup from 'yup';

// Defaults
export const formValues = {
    warehouse: '',
    newWarehouse: ''
}

export const validation = () => (
    Yup.object({
        warehouse: Yup.string()
            .required('Názov skladu je povinný.')
            .min(1, 'Minimálny počet znakov je 1.')
            .max(25, 'Maximálny počet znakov je 25.'),
        newWarehouse: Yup.string()
            .required('Názov skladu je povinný.')
            .min(1, 'Minimálny počet znakov je 1.')
            .max(25, 'Maximálny počet znakov je 25.'),

        })
        
);

